import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReportsComponent } from './components/reports/reports.component';
import { AdminComponent } from './components/admin/admin.component';
import { AdminChartPusherComponent } from './components/admin-chart-pusher/admin-chart-pusher.component';
import { ManageReportsComponent } from './components/manage-reports/manage-reports.component';
import { ReportEmbedComponent } from './components/report-embed/report-embed.component';
import { ManageReportSecurityComponent } from './components/manage-report-security/manage-report-security.component';
import { PendingChangesGuard } from './guards/can-deactivate.guard';
import { ManageReportGmadminComponent } from './components/manage-report-gmadmin/manage-report-gmadmin.component';


const routes: Routes = [
  { path: '', 
    redirectTo: (window.location.href.indexOf('admin') == -1)  ? 'reports' : 'admin', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'auth', redirectTo: 'dashboard' },
  { path: 'reports', component: ReportsComponent },
  { path: 'reports/viewas/:bac', component: ReportsComponent },
  { path: 'reports/viewas/:bac/:userId', component: ReportsComponent },
  { path: 'reports/manage', component: ManageReportsComponent },
  { path: 'reports/manage/:id', component: ManageReportSecurityComponent },
  { path: 'reports/manage/gm/:id', component: ManageReportGmadminComponent, canDeactivate: [PendingChangesGuard] },
  { path: 'reports/embed/:id', component: ReportEmbedComponent },
  { path: 'reports/viewas/embed/:id/:bac', component: ReportEmbedComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'admin/push-chart', component: AdminChartPusherComponent},
  { path: 'admin/push-chart/:chartGuid/:timeFrameId', component: AdminChartPusherComponent},
  { path: 'admin/viewas/:id', component: DashboardComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
